const Unavailable = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        fontFamily: 'sans-serif',
        fontSize: '1.5rem',
      }}
    >
      currently unavailable
    </div>
  );
};

export default Unavailable;
